import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import withAuthorization from '../higherOrder/withAuthorization'

import { DEVICES } from '../../constants/routes'
import { getDevice, resetDeviceError, startAddPlantToSensor, removePlantFromSensor, removeSensor } from '../../actions'
import { FillerDiv, CenteredDiv } from '../StyledComponents/Fillers'
import SensorDetails from '../Devices/SensorDetails'
import ValveDetails from '../Devices/ValveDetails'
import LoadingSpinner from '../Global/LoadingSpinner'
import NotFoundPage from './NotFound'
import LoadingOverlay from '../Global/LoadingOverlay'

class DeviceDetailsPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            removePlantId: false,
            removeSensorId: false,
        }

        this.onRemovePlantClicked = this.onRemovePlantClicked.bind(this)
        this.onRemoveSensorClicked = this.onRemoveSensorClicked.bind(this)
        this.loadDeviceDetails = this.loadDeviceDetails.bind(this)
    }

    componentDidMount() {
        const { devices, match } = this.props

        if (!devices[match.params.uuid]) {
            this.loadDeviceDetails()
        }
    }

    componentWillReceiveProps(nextProps) {
        const { devices } = nextProps
        const { match, history } = this.props
        const { removePlantId, removeSensorId } = this.state

        const device = devices[match.params.uuid]

        if (!!removePlantId && !!device) {
            if (!device.plants.includes(removePlantId)) {
                this.setState({ removePlantId: false })
            }
        }

        if (!!removeSensorId && !device) {
            this.setState({ removeSensorId: false })
            history.push(DEVICES)
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.sessionState.idToken && !!this.props.sessionState.idToken) {
            this.loadDeviceDetails()
        }
    }

    componentWillUnmount() {
        this.props.resetDeviceError()
    }

    onRemovePlantClicked(plantId) {
        const { removePlant, match, sessionState } = this.props

        if (!!sessionState && !!sessionState.authUser && !!sessionState.idToken) {
            const { token } = sessionState.idToken
            const { uid } = sessionState.authUser
            this.setState({ removePlantId: plantId })
            removePlant(uid, token, match.params.uuid, plantId)
        }
    }

    onRemoveSensorClicked(sensorId) {
        const { remove, sessionState } = this.props


        if (!!sessionState && !!sessionState.authUser && !!sessionState.idToken) {
            const { token } = sessionState.idToken

            this.setState({ removeSensorId: sensorId })
            remove(token, sensorId)
        }
    }

    loadDeviceDetails() {
        const {
            devices, match, type, sessionState,
        } = this.props

        if (!devices[match.params.uuid]) {
            if (sessionState.idToken) {
                const { token } = sessionState.idToken
                this.props.getDevice(match.params.uuid, type, token)
            }
        }
    }

    render() {
        const {
            devices, match, type, startAddPlant,
        } = this.props

        const device = devices ? devices[match.params.uuid] : null

        if (!device) {
            if (devices.error) {
                return <NotFoundPage />
            }
            return <CenteredDiv><LoadingSpinner /></CenteredDiv>
        }

        let deviceDetails = null
        switch (type) {
            case 'sensor':
                deviceDetails = (
                    <SensorDetails
                        onAddPlant={startAddPlant}
                        onRemovePlant={this.onRemovePlantClicked}
                        onRemoveSensor={this.onRemoveSensorClicked}
                        device={device}
                    />
                )
                break
            case 'valve':
                deviceDetails = <ValveDetails device={device} />
                break
            default:
        }

        const { removePlantId, removeSensorId } = this.state
        const loadingOverlay = removePlantId || removeSensorId
            ? <LoadingOverlay />
            : null

        return (
            <FillerDiv>
                {loadingOverlay}
                {deviceDetails || 'Device not compatible yet...'}
            </FillerDiv>
        )
    }
}

const authCondition = authUser => !!authUser

const mapStateToProps = state => ({
    devices: state.devices,
    sessionState: state.sessionState,
})

export default compose(
    withAuthorization(authCondition),
    connect(mapStateToProps, {
        getDevice,
        resetDeviceError,
        startAddPlant: startAddPlantToSensor,
        removePlant: removePlantFromSensor,
        remove: removeSensor,
    })
)(DeviceDetailsPage)



// WEBPACK FOOTER //
// ./src/components/pages/DeviceDetails.js